// extracted by mini-css-extract-plugin
module.exports = {"fullHeight":"product-scenes-section_fullHeight__e0lvI","sceneContainer":"product-scenes-section_sceneContainer__tTnJW"};